import { Avatar, Box, List, ListItem, ListItemAvatar, ListItemButton, ListItemText } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { Autosizer, Scrollbar } from 'app/components';
import { TransportRoundedIcon } from 'app/icons';
import React, { forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { FixedSizeList } from 'react-window';
const TransportGroupTransportList = () => {
    const { transports } = useSelector((state) => state.transport.groupSelectedItem);
    return (React.createElement(Box, { component: 'div', sx: (theme) => ({
            width: '100%',
            height: '100%',
            '.simplebar-offset > div': {
                '&::-webkit-scrollbar': {
                    width: 0,
                },
                '&::-webkit-scrollbar-track': {
                    background: 'transparent',
                    boxShadow: 'none',
                },
                '&::-webkit-scrollbar-thumb': {
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                },
            },
            '.MuiListItem-root': {
                width: '100%',
                userSelect: 'none',
                padding: theme.spacing(0),
                borderRadius: '0',
                '&:hover': {
                    cursor: 'pointer',
                    bgcolor: 'background.default',
                },
                '&.Mui-selected': {
                    '.MuiListItemText-root': {
                        bgcolor: theme.palette.primary.main,
                        color: theme.palette.primary.contrastText,
                    },
                },
                '.MuiListItemButton-root': {
                    padding: theme.spacing(1, 2),
                    borderRadius: '0',
                },
                '.MuiListItemText-root': {
                    display: 'flex',
                    flex: 'none',
                    height: '100%',
                    margin: theme.spacing(0),
                    padding: theme.spacing(0, 1),
                    alignItems: 'center',
                    '&:first-of-type': {
                        paddingLeft: theme.spacing(2),
                    },
                    '&:last-of-type': {
                        flex: '1',
                        paddingRight: theme.spacing(2),
                    },
                    '.MuiTypography-root': {
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                        textOverflow: 'ellipsis',
                    },
                },
                '.MuiListItemAvatar-root': {
                    minWidth: '26px',
                },
                '.MuiAvatar-circular': {
                    width: '24px',
                    height: '24px',
                    color: theme.palette.primary.main,
                    padding: theme.spacing(0),
                    bgcolor: alpha(theme.palette.primary.main, 0.12),
                    svg: {
                        fontSize: '16px',
                        path: {
                            fill: theme.palette.primary.main,
                        },
                    },
                },
            },
        }) },
        React.createElement(Autosizer, null, ({ height, width }) => (React.createElement(Box, { sx: { height, width } },
            React.createElement(Scrollbar, null, ({ scrollableNodeRef, contentNodeRef }) => (React.createElement(FixedSizeList, { height: height, itemSize: 36, overscanCount: 10, itemCount: transports.length, innerRef: contentNodeRef, outerRef: scrollableNodeRef, innerElementType: TransportGroupTransportInnerElementType, itemData: {
                    items: transports,
                } }, TransportGroupTransportItemRender))))))));
};
const TransportGroupTransportInnerElementType = forwardRef((props, ref) => (React.createElement(List, Object.assign({ ref: ref, disablePadding: true }, props))));
TransportGroupTransportInnerElementType.displayName = 'TransportGroupTransportInnerElementType';
const TransportGroupTransportItemRender = ({ data, index, style }) => {
    const { items } = data;
    const item = items[index];
    return (React.createElement(ListItem, { key: item.id, style: style },
        React.createElement(ListItemButton, null,
            React.createElement(ListItemAvatar, null,
                React.createElement(Avatar, null,
                    React.createElement(TransportRoundedIcon, { fontSize: 'small' }))),
            React.createElement(ListItemText, { primary: item.name }))));
};
export default TransportGroupTransportList;
